module.exports = __webpack_public_path__ + "static/media/post-cover.985b4555.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/post-cover.jpeg
// module id = 1030
// module chunks = 0